module.exports = __webpack_public_path__ + "img/icon-arrow-right-double.41a431dd.svg";